import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { IReviewWidgetAggregateComponent, ReviewWidgetAggregateComponent } from "./reviewWidgetAggregateComponent";

export interface IHeaderReviewWidget extends IInstanceComponentBase {
    reviewsAverage: number; 
    totalReviews: number;
    update: (reviewsAverage: number, totalReviews: number) => void;
}
export class HeaderReviewWidget extends InstanceComponentBase implements IHeaderReviewWidget {
    public reviewsAverage: number; 
    public totalReviews: number;

    public reviewWidgetAggregateComponent: IReviewWidgetAggregateComponent;

    constructor(public htmlElement: HTMLElement) {
        super(htmlElement);

        this.createReviewWidgetAggregateComponent();

        this.setReviewsAverage();
        this.setTotalReviews();
    }

    createReviewWidgetAggregateComponent():void{
        this.reviewWidgetAggregateComponent = new ReviewWidgetAggregateComponent(this.htmlElement);
    }

    setReviewsAverage():void{
        this.reviewsAverage = this.reviewWidgetAggregateComponent.reviewsAverage;
    }

    setTotalReviews():void{
        this.totalReviews = this.reviewWidgetAggregateComponent.totalReviews;
    }

    update(reviewsAverage: number, totalReviews: number): void {
        this.reviewWidgetAggregateComponent.update(reviewsAverage, totalReviews);
        this.setReviewsAverage();
        this.setTotalReviews();
    }

    dispose()
    {
        try {
            console.log(`HeaderReviewWidget: dispose`);          
            if (this.reviewWidgetAggregateComponent) {
                this.reviewWidgetAggregateComponent.dispose();
            }
        } catch (error) {
            console.log('HeaderReviewWidget: dispose ERROR', error);
        }
    }

}